import httpd from '../utils/axios';
import Vue from 'vue';
import {EventBus} from '../utils/event-bus';
import {get, isEmpty, replace, debounce} from 'lodash';
import WkMethods from '../extension/methods.js';
import Wallkit from '../plugins/wallkit.esm.min.js';
import {Base64} from 'js-base64';
import debug from '../utils/debug';

let _vue = null;
let _EventBus = null;
let dynamicRenderComponent = null;
let lazyLoadComponent = null;

export default {
  middleware: 'preload',
  data() {
    return {
      template: this.$route.params.template,
      version: null,
      reactive: 0,
      integrationShow: false,
      user: null,
      resource: null,
      token: null,
      stripe: null,
    }
  },
  template: `
    <div>
    <integration v-if="integrationShow" :key="reactive"></integration>
    </div>`,
  watch: {
    '$route'() {
      _EventBus.$emit('wk-lazy-comp-ready', false);
      this.startDynamicComponent(this.$route.params.template);
      this.reactive++;
    }
  },
  methods: {
    startDynamicComponent(template, version) {
      Vue.component("integration", (resolve) => {
        lazyLoadComponent(resolve, template, version);
      });
      this.integrationShow = true;
    },
    executeDynamicTitle(data) {

      if (!isEmpty(data.title)) {
        document.title = data.title;
      }
    },
    executeDynamicCss(data) {

      this.$store.dispatch('css/clearCss');
      const css = Base64.decode(get(data, 'css'));
      const name = get(data, 'name');

      if (!isEmpty(css) && !isEmpty(name) && this.$route.path.indexOf(data.slug) > -1) {

        const cssId = 'wallkit-css-' + name;
        let style = document.createElement('style');
        style.type = 'text/css';
        style.id = cssId;
        style.innerHTML = css;
        document.getElementsByTagName('head')[0].appendChild(style);
        this.$store.dispatch('css/pushCssId', cssId);
      }
    },
    checkSettings(data) {

      const settings = get(data, 'settings');
      if (isEmpty(settings)) {
        return true;
      }

      if (get(settings, 'required.auth') && !Wallkit.isAuthenticated()) {
        debug.log("Template required auth");
        debug.log('TEMPLATE REDIRECT:', data.slug + window.location.search);
        this.redirect('sign-up', data.slug + window.location.search);
        return false;
      }

      return true;
    },
    getQueryParam(name) {

      let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
      match = match && decodeURIComponent(match[1].replace(/\+/g, ' '));
      if (typeof match === "undefined" || typeof match === "null" || !match || match === "null" || match === "undefined") {
        return "";
      }
      return match;
    },
    redirect(path, next_redirect) {

      if (next_redirect) {
        next_redirect = replace(next_redirect, 'redirect=', '');
        path += '?redirect=' + encodeURIComponent(next_redirect);
      }

      if (!path) {
        path = this.getQueryParam("redirect");
      }

      if (path) {

        if (path.charAt(0) !== "/") {
          path = "/" + path
        }

        debug.log("REDIRECT TO", path);
        this.$router.replace({path: path, query: this.$route.query});

      }
    },
  },
  mounted() {

    dynamicRenderComponent = function (resolve, response) {

      const slug = get(response.data, 'slug');
      const template = Base64.decode(get(response.data, 'template'));
      const name = get(response.data, 'name');

      if (isEmpty(slug) || isEmpty(template) || isEmpty(name)) {
        throw new Error("Incorrect template");
      }

      resolve({
        name: slug,
        data: function () {
          return {
            template: null,
            error_description: null,
            error: false,
            params: {},
            stripe: null
          }
        },
        template: `
          <div>${template}</div>`,
        ready: function () {
          window.addEventListener('resize', debounce(this.onResize, 500))
        },
        beforeDestroy: function () {
          window.removeEventListener('resize', this.onResize)
        },
        methods: {
          _callback() {
            const javascript = Base64.decode(get(response.data, 'javascript'));

            if (!isEmpty(javascript)) {
              return (new Function("return " + javascript)())(this);
            } else {
              return (new Function("return (instance) => { }")())(this);
            }
          },
          redirect(path, redirect) {
            _vue.redirect(path, redirect);
          },
          onResize() {
            this.resize();
          },
          refresh() {
            _vue.reactive++;
          },
        },
        mixins: [WkMethods],
        mounted() {

          setTimeout(() => {
            this.onResize();
          }, 1000);

          setTimeout(() => {
            this.onResize();
          }, 2000);

          setTimeout(() => {
            this.onResize();
          }, 5000);

          window.onresize = () => {
            debounce(this.onResize, 500)
          };

          setTimeout(() => {
            _EventBus.$emit('wk-lazy-comp-ready', true);
            this.onResize();
          }, 10);

        },
        created() {

          this.params = _vue.$route.query;

          try {
            this.template = this._callback.call(null);
          } catch (error) {
            debug.log('-----javascript render error-------');
            debug.log(error);
            _vue.$router.replace('Page500');
          }

        },
      });
    };

    lazyLoadComponent = function (resolve, template, version) {

      let url = `/integrations/templates/${template}`;
      // let url = `http://localhost:3005/templates/${template}`;

      if (!isEmpty(version)) {
        url += `/v?=${version}`;
      }

      httpd.get(url)
        .then(response => {

          if (!_vue.checkSettings(response.data)) {
            return false;
          }
          _vue.executeDynamicCss(response.data);
          _vue.executeDynamicTitle(response.data);

          resolve({
            data() {
              return {
                divId: 'wallkit-'
              }
            },
            template: `
              <div>
              <${response.data.slug} :template="template" :id="divId"></${response.data.slug}>
              </div>`,
            props: [
              'template'
            ],
            mixins: [WkMethods],
            created() {
              this.divId += response.data.slug;
              Vue.component(response.data.name, (resolve) => {
                try {
                  dynamicRenderComponent(resolve, response)
                } catch (error) {
                  debug.log('-----template render error-------');
                  debug.log(error);
                }
              })
            },
          })

        })
        .catch(error => {
          debug.log('-----load template error-------');
          debug.log(error);
          _vue.$router.replace('Page404');
        })
    };

    this.startDynamicComponent(this.template, this.version);

    /**
     * reload laze component on event
     */
    EventBus.$on("wk-lazy-comp-reload", (value) => {
      if (value) this.reactive++;
    })
  },
  created: function () {

    this.template = this.$route.params.template;
    debug.log("Template:", this.template);
    _vue = this;
    _EventBus = EventBus;
  },

}



// WEBPACK FOOTER //
// ./src/components/LazyDynamicPage.js